import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advanced from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);

export function dayjsToStringDate(date: Dayjs) {
  return date.format('YYYY-MM-DD');
}

export function today(timezoneArg?: string) {
  return dayjs().tz(timezoneArg || "America/Chicago").startOf("day").format("YYYY-MM-DD");
}

export function addDaysToDate(date: string, days: number): string {
  return dayjs(date).add(days, 'days').format('YYYY-MM-DD');
}

export function addMonthsToDate(date: string, months: number): string {
  return dayjs(date).add(months, 'months').format('YYYY-MM-DD');
}

export function subtractDates(date: string, dateTwo: string): number {
  return dayjs(date).diff(dateTwo, 'day');
}

export function formatDateForPreview(date?: string) {
  if (!date) {
    return '';
  }

  return dayjs(date).format('MM/DD/YYYY');
}
export function serializeDateToString(date?: Date) {
  return dayjs(date).format('YYYY-MM-DD');
}

export function formatDatetimeAsTimeForElog(dateTime?: string, timezoneArg?: string) {
  return dayjs(dateTime)
    .tz(timezoneArg || 'America/Chicago')
    .format('HH:mm:ss');
}

export function formatTimeForPreview(dateTime?: string, timezoneArg?: string) {
  if (!dateTime) {
    return '';
  }

  return dayjs(dateTime)
    .tz(timezoneArg || 'America/Chicago')
    .format('h:mma');
}


export function formatDatetimeForPreview(dateTime?: string, timezoneArg?: string) {
  if (!dateTime) {
    return '';
  }

  return dayjs(dateTime)
    .tz(timezoneArg || 'America/Chicago')
    .format('MM/DD/YYYY h:mma');
}

export function formatTimeAsHourMin(decimal: number) {
  const diff = decimal - Math.floor(decimal);
  if (diff > 0 && 1 - diff < 0.00001) {
    decimal = Math.ceil(decimal);
  }
  const hours = Math.floor(decimal);

  const minutes = Math.min(59, Math.round((decimal - hours) * 60));

  // Format hours and minutes
  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  // Return the time in HH:mm format
  return `${formattedHours}:${formattedMinutes}`;
}
